module.exports = __webpack_public_path__ + "officialStatic/img/shiPinCode.bd71bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/shiPinCode.png
// module id = 2t8Z
// module chunks = 0